import { IGanttController } from "elements/gantt/controller";
import { trackGanttEvent } from "elements/gantt/utils";
import { Group, Path } from "react-konva";
import { KonvaButton } from "frontend/canvas-designer-new/utility-elements/konva-button";

type AddTaskButtonProps = {
  x: number;
  y: number;
  controller: IGanttController;
};

export const AddActions = ({ x, y, controller }: AddTaskButtonProps) => {
  const actions = [
    // {
    //   title: "Add Row",
    //   onClick: () => {
    //     controller.addSplitLastRow();
    //     trackGanttEvent("gantt_row_added", {
    //       from: "gantt_actions",
    //     });
    //   },
    // },
    // {
    //   title: "Add Column",
    //   onClick: () => {
    //     controller.addSplitColumnRight();
    //     trackGanttEvent("gantt_column_added", {
    //       from: "gantt_actions",
    //     });
    //   },
    // },
    {
      title: "Add Task",
      onClick: async () => {
        const didCreateTask = await controller.createTask();
        if (didCreateTask) {
          trackGanttEvent("gantt_task_created", {
            from: "gantt_actions",
            amount: controller.getTaskCells().length + 1,
            type: "taskCard",
          });
        }
      },
    },
  ];
  return (
    <Group x={x} y={y}>
      {actions.map((action) => {
        return (
          <KonvaButton
            key={action.title}
            x={0}
            y={0}
            text={action.title}
            textColor="#0072ff"
            Icon={
              <Path
                data={"M6.825 5.214V0H5.25v5.214H0v1.565h5.25V12h1.575V6.78h5.247V5.213z"}
                fill={"#0072ff"}
                lineCap="round"
                lineJoin="round"
                width={30}
                // height={20}
              />
            }
            backgroundColor={"#f0f1f5"}
            hoverColor="#d1e3ff"
            onClick={() => {
              action.onClick();
            }}
          />
        );
      })}
    </Group>
  );
};
